export const SCHEDULE = "schedule";
export const SCHEDULE_CREATE = "createSchedule";
export const SCHEDULE_BACK = "scheduleBack";
export const SCHEDULE_DETAIL = "scheduleDetail";
export const SCHEDULE_EDIT = "scheduleEdit";